import API from '../../../../../services/api';

export const AVISOS_TIPO_PIEZA_API = {
    get: async () => {
        return await API.get('/avisos_tipo_piezas').then(res => res.data);
    },
    new: async (aviso) => {
        return API.post('/avisos_tipo_piezas', aviso).then(res => res.data);
    },
    update: async (aviso) => {
        return API.put('/avisos_tipo_piezas/' + aviso.id, aviso).then(res => res.data);
    }
}